// extracted by mini-css-extract-plugin
module.exports = {"a":"Kq-kSat3OS15OydI_cYQB","logo":"_20bLp-pmK8K1FhtIZUPKE2"};